<template>
  <div class="user">
    <!-- 搜索栏 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input placeholder="请输入姓名" v-model="formInline.name"></el-input>
        </el-form-item>

                 <!-- <el-form-item label="企业id">
          <el-input placeholder="请输入企业id" v-model="formInline.supply_id">
        
          </el-input>
          
        </el-form-item> -->
    
        <el-form-item>
              <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作栏 -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加核心人员</el-button>
    </div>

    <!-- 表格内容 -->
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- 头像列 -->
            <el-table-column label="头像" width="80" align="center">
              <template slot-scope="scope">
                <el-avatar :size="50" :src="scope.row.image" v-if="scope.row.image"></el-avatar>
                <el-avatar :size="50" icon="el-icon-user-solid" v-else></el-avatar>
              </template>
            </el-table-column>
            
            <el-table-column prop="name" label="姓名" width="120"></el-table-column>
            <!-- <el-table-column prop="enterprise_name" label="所属协会"></el-table-column> -->
            <el-table-column prop="position" label="企业职位"></el-table-column>
            <el-table-column prop="cposition" label="简介"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 添加/编辑弹窗 -->
    <el-dialog
      :title="isEditMode ? '编辑核心人员' : '添加核心人员'"
      :visible.sync="dialogVisible"
      width="50%"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form 
        :model="currentMember" 
        label-width="100px"
        size="small"
        ref="memberForm"
      >
   

        <el-form-item label="头像">
          <div class="draggable-list">
            <div v-if="currentMember.avatar" class="item">
              <img v-img-url="currentMember.avatar" alt="头像"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteAvatar">
                <i class="el-icon-close"></i>
              </a>
            </div>
            <div class="item img-select" @click="openAvatarUpload">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="el-upload__tip">建议尺寸：300x300像素，支持JPG、PNG格式</div>
        </el-form-item>

        <el-form-item label="姓名" prop="name" :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
          <el-input v-model="currentMember.name" placeholder="请输入姓名" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="职位">
          <el-input v-model="currentMember.position" placeholder="请输入企业职位" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="简介">
          <el-input 
            v-model="currentMember.responsibility" 
            type="textarea"
            :rows="3"
            placeholder="请输入简介"
            class="max-w460"
          ></el-input>
        </el-form-item>
          <el-form-item label="排序" prop="name">
          <el-input v-model="currentMember.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
    <!-- 头像上传弹窗 -->
    <Upload 
      v-if="isAvatarUpload" 
      :config="{ total: 1 }" 
      :isupload="isAvatarUpload" 
      @returnImgs="handleAvatarUpload"
      @close="isAvatarUpload = false"
    >
      上传头像
    </Upload>
  </div>
</template>

<script>
import EnterpriseApi from '@/api/enterprise.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    Upload
  },
  data() {
    return {
      loading: true,
      tableData: [],
      enterprise: [], // 存储协会列表数据
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        name: "",
        enterprise_id: "", // 新增协会筛选字段
        position: ""
      },
      dialogVisible: false,
      currentMember: {
        enterprise_id: '', // 所属协会ID
        avatar: '',
        name: '',
        position: '',
        responsibility: '',
        sort:50
      },
      isEditMode: false,
      editId: null,
      isAvatarUpload: false,
      supply_id:0,
    };
  },
  created() {

    this.supply_id =  this.$route.query.supply_id;
    
    this.formInline.supply_id = this.$route.query.supply_id;
    this.getTableList();
    this.getEnterpriseList(); // 加载协会列表
  },
  methods: {
            /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
    /* 获取协会列表 */
    getEnterpriseList() {
      EnterpriseApi.list({}, true)
        .then(response => {
          this.enterprise = response.data.list.data;
        })
        .catch(error => {
          console.error('获取协会列表失败:', error);
        });
    },

    /* 获取核心人员列表数据 */
    getTableList() {
      let self = this;
      let Params = {
        ...this.formInline,
        page: self.curPage,
        list_rows: self.pageSize
      };
      
      self.loading = true;
      Params.supply_id = self.supply_id
      EnterpriseApi.getCoreMembers(Params)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    /* 重置搜索条件 */
    resetSearch() {
      this.formInline = {
        name: "",
        enterprise_id: "",
        position: ""
      };
      this.curPage = 1;
      this.getTableList();
    },
    
    /* 搜索查询 */
    getData() {
      this.curPage = 1;
      this.getTableList();
    },

    /* 分页处理 */
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /* 添加核心人员 */
    addClick() {
      this.currentMember = {
        enterprise_id: '',
        avatar: '',
        name: '',
        position: '',
        responsibility: '',
        sort:50,
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },

    /* 编辑核心人员 */
    editClick(row) {
      this.currentMember = { 
        enterprise_id: row.enterprise_id,
        avatar: row.image,
        name: row.name,
        position: row.position,
        responsibility: row.cposition,
        sort:row.sort,
        core_members_id:row.core_members_id
      };
      this.isEditMode = true;
      this.editId = row.id;
      this.dialogVisible = true;
    },

    /* 删除核心人员 */
    deleteClick(row) {
      this.$confirm('此操作将永久删除该核心人员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        EnterpriseApi.deleteCoreMember({
          core_members_id:row.core_members_id
        })
          .then(data => {
            if (data.code == 1) {
              this.$message.success('删除成功');
              this.getTableList();
            } else {
              this.$message.error(data.msg || '删除失败');
            }
          })
          .catch(error => {
            this.$message.error('删除失败');
          });
      }).catch(() => {});
    },

    /* 打开头像上传弹窗 */
    openAvatarUpload() {
      this.isAvatarUpload = true;
    },
    
    /* 处理头像上传结果 */
    handleAvatarUpload(e) {
      if (e && e.length > 0) {
        this.currentMember.avatar = e[0].file_path;
      }
      this.isAvatarUpload = false;
    },
    
    /* 删除头像 */
    deleteAvatar() {
      this.currentMember.avatar = '';
    },

    /* 关闭弹窗 */
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.memberForm.resetFields();
    },
    
    /* 提交表单 */
    submitForm() {


      this.currentMember.supply_id = this.supply_id
      this.$refs.memberForm.validate(valid => {
        if (valid) {
          const apiCall = this.isEditMode 
            ? EnterpriseApi.updateCoreMember(this.currentMember)
            : EnterpriseApi.addCoreMember(this.currentMember);
          
          apiCall.then(response => {
            this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
            this.dialogVisible = false;
            this.getTableList();
          }).catch(error => {
            this.$message.error(this.isEditMode ? '更新失败' : '添加失败');
          });
        }
      });
    }
  }
};
</script>

<style scoped>
/* 保持与原有样式一致 */
.common-seach-wrap {
  padding: 20px 20px 0;
}
.common-level-rail {
  padding: 10px 20px;
  background: #fff;
  border-radius: 2px;
}
.product-content {
  padding: 10px 20px 20px;
  background: #fff;
  margin: 20px;
  border-radius: 2px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.max-w460 {
  max-width: 460px;
}

/* 头像上传样式 */
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/enterprise/core_members/core_members.vue